import React from "react";

import { Collapsible } from "~/components/collapsible";
import { CollapsibleContent } from "~/components/collapsible/content";
import { CollapsibleTrigger } from "~/components/collapsible/trigger";
import { IconChevronDown } from "~/components/icon";

import type { SourceLinkPartType } from "./_part-types";
import { SourceLinkChip } from "./_source-link-chip";
import type { ComponentViewMode } from "./_use-navigate-to-component";

export const SourceLinkGroup: React.FC<{
	parts: ReadonlyArray<SourceLinkPartType>;
	onNavigateToComponent?: (identifier: string, mode?: ComponentViewMode) => void;
}> = ({ parts, onNavigateToComponent }) => (
	<Collapsible className="flex flex-col gap-1.5" defaultOpen>
		<CollapsibleTrigger className="flex items-center gap-1 font-semibold text-10 text-gray-400 uppercase tracking-wider hover:text-gray-600">
			<IconChevronDown className="size-3 transition-transform group-state-closed/collapsible:-rotate-90" />
			Sources
		</CollapsibleTrigger>
		<CollapsibleContent>
			<div className="flex flex-wrap gap-1">
				{parts.map((part, index) => (
					<SourceLinkChip
						key={part.part_id ?? `source_link:${part.urn ?? part.url ?? part.label ?? ""}:${index}`}
						onNavigateToComponent={onNavigateToComponent}
						part={part}
					/>
				))}
			</div>
		</CollapsibleContent>
	</Collapsible>
);
